export const CONTACT = {
  phone: "613-716-1119",
  phoneHref: "tel:+16137161119",
  email: "info@aspendesign.ca",
  address: "3326 Limebank Rd bay 2, Ottawa, ON K1V 1H2",
  areas: ["Ottawa", "Gatineau", "Kingston", "Cornwall"],
};

export const SEQUENCE_FRAMES = [
  {
    label: "The Approach",
    url: "https://images.unsplash.com/photo-1631048500348-35da7398a264?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  },
  {
    label: "The Island",
    url: "https://images.unsplash.com/photo-1631048501619-a27088a3bb70?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  },
  {
    label: "Calacatta Marble",
    url: "https://images.pexels.com/photos/38311097/pexels-photo-38311097.jpeg?auto=compress&cs=tinysrgb&w=1920",
  },
  {
    label: "Navy Cabinetry",
    url: "https://images.pexels.com/photos/14495883/pexels-photo-14495883.jpeg?auto=compress&cs=tinysrgb&w=1920",
  },
  {
    label: "The Cooking Suite",
    url: "https://images.unsplash.com/photo-1571843439991-dd2b8e051966?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  },
  {
    label: "The Reveal",
    url: "https://images.pexels.com/photos/6587896/pexels-photo-6587896.jpeg?auto=compress&cs=tinysrgb&w=1920",
  },
];

export const EXPERTISE = [
  {
    id: "residential",
    title: "Residential",
    subtitle: "Bespoke Kitchen Renovations, Custom Islands & Luxury Home Upgrades",
    points: [
      "Navy & walnut custom cabinetry",
      "Waterfall marble islands",
      "Architectural millwork & paneling",
      "Master ensuite retreats",
    ],
  },
  {
    id: "commercial",
    title: "Commercial",
    subtitle: "Restaurant Fit-Outs, Pharmacy Renovations & Building Upgrades",
    points: [
      "Bespoke hospitality interiors",
      "Medical & pharmacy fit-outs",
      "Comprehensive building modernization",
      "Turnkey general contracting",
    ],
  },
];

export const MARQUEE_ITEMS = [
  "BESPOKE KITCHENS",
  "CUSTOM MARBLE ISLANDS",
  "LUXURY HOME UPGRADES",
  "COMMERCIAL FIT-OUTS",
  "PHARMACY RENOVATIONS",
  "RESTAURANT DESIGN",
];

export const PROJECTS = [
  {
    id: "port-1",
    title: "The Rockcliffe Manor Kitchen",
    category: "Residential Kitchen",
    location: "Ottawa, ON",
    url: "https://images.unsplash.com/photo-1631048500348-35da7398a264?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    span: "col-span-12 lg:col-span-8 lg:row-span-2",
  },
  {
    id: "port-2",
    title: "Gatineau Hills Master Ensuite",
    category: "Luxury Bathroom",
    location: "Gatineau, QC",
    url: "https://images.unsplash.com/photo-1576698483491-8c43f0862543?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "col-span-12 sm:col-span-6 lg:col-span-4",
  },
  {
    id: "port-3",
    title: "L'Avenue Cocktail Bar & Dining",
    category: "Commercial Fit-Out",
    location: "Kingston, ON",
    url: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "col-span-12 sm:col-span-6 lg:col-span-4 lg:row-span-2",
  },
  {
    id: "port-4",
    title: "The Westboro Custom Residence",
    category: "Architectural Renovation",
    location: "Ottawa, ON",
    url: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    span: "col-span-12 lg:col-span-8",
  },
  {
    id: "port-5",
    title: "Limebank Commercial Pharmacy",
    category: "Commercial Renovation",
    location: "Cornwall, ON",
    url: "https://images.pexels.com/photos/20705886/pexels-photo-20705886.jpeg?auto=compress&cs=tinysrgb&w=1200",
    span: "col-span-12 sm:col-span-6 lg:col-span-4",
  },
  {
    id: "port-6",
    title: "Marble Spa Bathroom Suite",
    category: "Luxury Bathroom",
    location: "Ottawa, ON",
    url: "https://images.pexels.com/photos/31525748/pexels-photo-31525748.jpeg?auto=compress&cs=tinysrgb&w=1200",
    span: "col-span-12 sm:col-span-6 lg:col-span-4",
  },
  {
    id: "port-7",
    title: "Kingston Bistro Interior",
    category: "Commercial Hospitality",
    location: "Kingston, ON",
    url: "https://images.unsplash.com/photo-1531973968078-9bb02785f13d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "col-span-12 sm:col-span-6 lg:col-span-4",
  },
];

export const SERVICE_AREAS = {
  primary: [
    {
      name: "Ottawa",
      coords: [45.4215, -75.6972],
      blurb: "Headquarters & workshop — 3326 Limebank Rd, Bay 2",
    },
    {
      name: "Gatineau",
      coords: [45.4765, -75.7013],
      blurb: "Residential estates & commercial renovations",
    },
    {
      name: "Kingston",
      coords: [44.2312, -76.486],
      blurb: "Hospitality fit-outs & heritage restorations",
    },
    {
      name: "Cornwall",
      coords: [45.0276, -74.7403],
      blurb: "Commercial upgrades & custom residences",
    },
  ],
  surrounding: [
    { name: "Kanata", coords: [45.3, -75.9161] },
    { name: "Orléans", coords: [45.4667, -75.5167] },
    { name: "Barrhaven", coords: [45.2733, -75.7353] },
    { name: "Manotick", coords: [45.2267, -75.6867] },
    { name: "Chelsea", coords: [45.5, -75.7833] },
    { name: "Aylmer", coords: [45.4, -75.85] },
    { name: "Carleton Place", coords: [45.1333, -76.1333] },
    { name: "Perth", coords: [44.9, -76.25] },
    { name: "Smiths Falls", coords: [44.9, -76.0167] },
    { name: "Gananoque", coords: [44.33, -76.16] },
    { name: "Brockville", coords: [44.5833, -75.6833] },
    { name: "Kemptville", coords: [45.0167, -75.65] },
    { name: "Rockland", coords: [45.55, -75.2833] },
    { name: "Hawkesbury", coords: [45.6, -74.6] },
    { name: "Alexandria", coords: [45.3167, -74.6333] },
    { name: "Morrisburg", coords: [44.9, -75.1833] },
  ],
};
